<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>
                    CONVERSA -
                    <b-badge variant="warning">{{operacao}}</b-badge>
                    <app-btn-voltar class="float-right ml-2" rota="Mensagens" variant="secondary"></app-btn-voltar>
                    <enviar
                        v-if="mensagem"
                        :mensagem="mensagem"
                        @obterMensagensEConversasAtualizadas="$emit('obterMensagensEConversasAtualizadas')"
                    />
                    <selecionar-destinatarios
                        v-if="mensagem"
                        :mensagem="mensagem"
						:opcaoSel="opcaoSel"
						@atualizarOpcaoSel="opcaoSel = $event"
                        @atualizarDestinatarios="destinatarios = $event"
                    ></selecionar-destinatarios>
                </h5>
            </b-card-header>
            <b-card-body>
                <cabecalho :mensagem="mensagemBase" v-if="status == 1"></cabecalho>
                <b-row v-if="mostrarDestinatarios">
                    <b-col sm="12">
                        <b-form-group>
                            <label>Destinatários</label>
                            <div class="form-control">
                                <strong>{{destinatariosTexto}}</strong>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Assunto</label>
                            <b-form-input
                                type="text"
                                v-model="assunto"
                                :disabled="desabilitarEdicao"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Mensagem</label>
                            <ckeditor
                                :editor="editor"
                                v-model="conteudo"
                                :config="editorConfig"
                                :disabled="desabilitarEdicao"
                            ></ckeditor>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br'
import SelecionarDestinatarios from './SelecionarDestinatarios'
import Enviar from './Enviar'
import Cabecalho from './Cabecalho'

export default {
    components: {
        SelecionarDestinatarios, 
        Enviar,
        Cabecalho
    },

    data() {
        return {
            operacao: 'NOVA',
            mensagemId: '',
            assunto: '',
            conteudo: '',
            status: 0,
            mensagemBase: {},
            editor: ClassicEditor,
            editorConfig: {
                language: 'pt-br',
                toolbar: [
                    'bold',
                    'italic',
                    'link',
                    '|',
                    'bulletedList',
                    'numberedList',
                    'blockQuote',
                    '|',
                    'insertTable',
                    '|',
                    'undo',
                    'redo'
                ]
            },
            destinatarios: [],
            opcaoSel: 0
        }
    },

    computed: {
        destinatariosTexto() {
            if (!this.destinatarios || this.destinatarios.length == 0)
                return 'TODOS OS FORNECEDORES'
            return this.destinatarios
                .map(item => item.razaoSocial)
                .join(' | ')
        },

        mensagem() {
            return {
                mensagemId: this.mensagemId,
                assunto: this.assunto,
                conteudo: this.conteudo,
                destinatarios: this.destinatarios,
                status: this.status
            }
        },

        mostrarDestinatarios() {
            let retorno =
                this.$store.getters.fornecedor.fornecedorId === null &&
                !this.mensagemBase.externa
            return retorno
        },

        desabilitarEdicao() {
            return this.status == 1
        }
    }
}
</script>
